import axios from "./axios";

//Muestras
export const getPlantaOptionsMuestras = () =>
    axios.get("/allPlantaOptions");
export const getAllOrdenTrabajoOptionsMuestras = () =>
    axios.get(`/allOrdenTrabajoOptions`);
export const getAllEquipoOptionsMuestras = () =>
    axios.get(`/allEquipoOptions`);
export const getAllConjuntoAnalisisOptionsMuestras = () =>
    axios.get(`/allConjuntoAnalisisOptions`);

export const getAllOrdenByClienteOptionsMuestras = (id: number) =>
    axios.get(`/allOrdenByPlantaIdOptions/${id}`);
export const getAllEquipoByClienteOptionsMuestras = (id: number) =>
    axios.get(`/allEquipo/planta/${id}/option`);
export const getAllOrdenByClienteOptionMuestras = (id: number) =>
    axios.get(`/allOrdenByClienteIdOptions/${id}`);



//modal
export const getAllOrdenByPuntoTomaOptionsMuestras = (id: number) =>
    (`allPuntoTomasByClienteIdOptions/${id}`); // cliente
///

//punto de toma //modal
export const getClienteOptions = () =>
    axios.get("/allClienteOptions");
export const getEquipoOptionsPuntoToma = () =>
    axios.get("/allEquipoOptions");
export const getLubricanteOptionsPuntoToma = () =>
    axios.get("/allLubricanteOptions");
export const getComponenteOptionsPuntoToma = () =>
    axios.get("/allComponenteOptions");

export const getEquipoOptionsByClientePuntoDeToma = (id: number) =>
    axios.get(`/allEquipoByClienteIdOption/${id}`);





//equipos
export const getPlantaOptionsEquipos = () =>
    axios.get("/allPlantaOptions");
export const getPlantaOptionsByClienteEquipos = (id: number) =>
    axios.get(`/allPlantaByClienteIdOptions/${id}`);